/* 🤖 this file was generated by svg-to-ts */
export const matIconClearAll: {
  name: 'clear-all';
  data: string;
} = {
  name: 'clear-all',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"/></svg>`
};
